import List from "@/components/list";
import Bus from "./Bus.js";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  function handleDelete(vo) {
    Bus.$emit("deleteExamRuleDetail", vo.row);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [["icon-delete", "删除", () => handleDelete(vo), ""]];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "资源分类",
      prop: "categoryName",
      minWidth: "150",
      render: e => {
        const item = e.row;
        return (
          <el-select
            placeholder="请选择资源分类"
            size="small"
            value={item.categoryId}
            onChange={val => {
              for (const ele of item.categoryList) {
                if (ele.id === val) {
                  Bus.$emit("selectCategory", ele, e.$index);
                  return;
                }
              }
            }}
          >
            {item.categoryList.map(ele => {
              return (
                <el-option
                  key={ele.id}
                  label={ele.name}
                  value={ele.id}
                ></el-option>
              );
            })}
          </el-select>
        );
      }
    },
    {
      label: "学时要求",
      prop: "examCredit",
      minWidth: "150",
      render: e => {
        return (
          <el-input
            type="number"
            placeholder="请输入学时"
            min={1}
            key={e.row.uuid}
            value={e.row.examCredit}
            onInput={value => {
              e.row.examCredit = value;
            }}
          ></el-input>
        );
      }
    },
    {
      label: "操作",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
